import React from 'react';
export function StopSearching() {
  return <section className="bg-navy2 px-4 py-4 sm:py-6" data-id="element-158" data-mp="1it4vryfhct5m">
      <div className="mx-auto max-w-3xl" data-id="element-159" data-mp="2mu4f7cacur66">
        <h2 className="text-center text-lg leading-tight text-white sm:text-3xl" data-id="element-160" data-mp="2mv5phejjr9mu">
          😩 STOP TROUBLESHOOTING EVERY FAILURE FROM SCRATCH
        </h2>
        <p className="mx-auto mt-1.5 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-161" data-mp="2duhdepdprjcl">
          You already know industrial maintenance.
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-162" data-mp="243cz7rvv42it">
          The problem is wasting time jumping between possible causes without a
          clear diagnostic sequence.
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-163" data-mp="1v517tnn690pb">
          Open the system, identify the symptom and follow the relevant checks.
        </p>
        <p className="mt-1.5 text-center font-head text-base font-bold uppercase tracking-[0.12em] text-volt sm:text-lg" data-id="element-164" data-mp="1l7d5abjbqowl">
          Less guessing. More structured troubleshooting.
        </p>
      </div>
    </section>;
}